import React, { Component } from 'react'
import { MagicSpinner } from "react-spinners-kit";

export default class loading extends Component {
    render() {
        return (
            <div className="loading">
                <MagicSpinner size={100} color="var(--green1)" loading={true} />
                <div style={{marginTop:'20px'}}>لطفاً شکیبا باشید</div>
            </div>
        )
    }
}
